import * as React from 'react'

import { FormikFormChunkProps } from '../../../types'
import NestedFormWrapper        from './NestedFormWrapper'

type AsNestedForm =
  <T>(FormChunk: React.ComponentType<FormikFormChunkProps<T>>) =>
    React.SFC<FormikFormChunkProps<T>>

const asNestedForm: AsNestedForm = FormChunk => {
  return props => (
    <NestedFormWrapper {...props}>
      {(innerProps: any) => <FormChunk {...innerProps} />}
    </NestedFormWrapper>
  )
}

export default asNestedForm



// WEBPACK FOOTER //
// ./src/components/forms/wrappers/asNestedForm.tsx